module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgMTggNCI+CiAgICA8cGF0aCBmaWxsPSIjODg4Qjk0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDBhMiAyIDAgMSAwIC4wMDEgNC4wMDFBMiAyIDAgMCAwIDIgMHptNyAwYTIgMiAwIDEgMCAuMDAxIDQuMDAxQTIgMiAwIDAgMCA5IDB6bTcgMGEyIDIgMCAxIDAgLjAwMSA0LjAwMUEyIDIgMCAwIDAgMTYgMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more.svg
// module id = AkLj
// module chunks = 0 158 178 181 193